// Coverage type configuration shared across Protection Center pages
export const COVERAGE_TYPES = [
  {
    slug: 'auto',
    label: 'Auto Insurance',
    emoji: '🚗',
    blurb: 'Personal vehicles, drivers, and savings discounts.',
  },
  {
    slug: 'home',
    label: 'Home Insurance',
    emoji: '🏡',
    blurb: 'Protect your biggest investment — your home.',
  },
  {
    slug: 'life',
    label: 'Life Insurance',
    emoji: '❤️',
    blurb: 'Protect the people who depend on you.',
  },
  {
    slug: 'business',
    label: 'Business Insurance',
    emoji: '🏢',
    blurb: 'General liability, property, workers comp, and more.',
  },
  {
    slug: 'commercial_auto',
    label: 'Commercial Auto',
    emoji: '🚙',
    blurb: 'Coverage for company vehicles and fleets.',
  },
  {
    slug: 'umbrella',
    label: 'Umbrella Coverage',
    emoji: '☂️',
    blurb: 'An extra layer above your existing policies.',
  },
  {
    slug: 'renters',
    label: 'Renters Insurance',
    emoji: '🏘️',
    blurb: 'Affordable protection for belongings and liability.',
  },
  {
    slug: 'medicare',
    label: 'Medicare Options',
    emoji: '👴',
    blurb: 'Guidance for Medicare Advantage, Supplement, and Part D.',
  },
];

export const COVERAGE_BY_SLUG = Object.fromEntries(
  COVERAGE_TYPES.map((c) => [c.slug, c])
);

export const BEST_TIMES = [
  'Morning (8am – 12pm)',
  'Afternoon (12pm – 5pm)',
  'Evening (5pm – 8pm)',
  'Anytime',
];
